<ps-drawer
  [title]="title"
  [subtitle]="subtitle"
  confirmLabel="Confirm"
  cancelLabel="Cancel"
  [confirmDisabled]="trackerConfigForm().invalid()"
  (confirmClicked)="onConfirm()"
  (cancelClicked)="onCancel()"
>
  <ps-drawer-body>
    <div class="mb-4">
      <ps-numeric-input
        id="tracker-config-number-of-waves"
        label="Number of waves"
        ariaLabel="Number of waves"
        data-cy="tracker-config-number-of-waves"
        [showStepper]="true"
        [formField]="trackerConfigForm.numberOfWaves"
      >
        <ps-info-tooltip-icon
          psLabelSuffix
          class="mb-2"
          ariaLabel="Number of waves description"
          size="xs"
          [content]="tooltips.numberOfWaves"
        />
      </ps-numeric-input>
      <p class="form-text text-xs text-muted mb-0">
        {{ helpTexts.numberOfWaves }}
      </p>
    </div>

    <div class="tracker-config-drawer-configuration-card">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <span class="fw-semibold">Configuration</span>
        <ps-button
          variant="link"
          color="primary"
          size="sm"
          ariaLabel="Reset to default"
          data-cy="tracker-config-reset-to-default"
          (clicked)="onResetToDefault()"
        >
          <ps-icon name="arrow-rotate-left" size="xs" aria-hidden="true" />
          Reset to default
        </ps-button>
      </div>

      <div class="mb-3">
        <div class="d-flex align-items-center gap-2 mb-1">
          <span class="form-label mb-0">Wave frequency</span>
          <ps-info-tooltip-icon
            ariaLabel="Wave frequency description"
            size="xs"
            [content]="tooltips.waveFrequency"
          />
        </div>

        <div class="d-flex gap-2">
          <ps-numeric-input
            id="tracker-config-wave-frequency-amount"
            ariaLabel="Wave frequency amount"
            data-cy="tracker-config-wave-frequency-amount"
            [showStepper]="true"
            [formField]="trackerConfigForm.waveFrequencyAmount"
          />

          <ps-single-select
            id="tracker-config-wave-frequency-unit"
            ariaLabel="Wave frequency unit"
            data-cy="tracker-config-wave-frequency-unit"
            [options]="frequencyUnitOptions"
            [formField]="trackerConfigForm.waveFrequencyUnit"
          />
        </div>

        <p class="form-text text-xs text-muted mb-0">
          {{ helpTexts.waveFrequency }}
        </p>
      </div>

      <div>
        <ps-single-select
          id="tracker-config-exclusion-rule"
          label="Exclusion Rules"
          ariaLabel="Exclusion rules"
          data-cy="tracker-config-exclusion-rule"
          [options]="exclusionRuleOptions"
          [formField]="trackerConfigForm.exclusionRuleKind"
        >
          <ps-info-tooltip-icon
            psLabelSuffix
            class="mb-2"
            ariaLabel="Exclusion rules description"
            size="xs"
            [content]="tooltips.exclusionRule"
          />
        </ps-single-select>
        <p class="form-text text-xs text-muted mb-0">
          {{ selectedExclusionRuleCaption() }}
        </p>

        @if (isCustomExclusion()) {
          <div class="mt-3">
            <ps-numeric-input
              id="tracker-config-waves-exclude"
              label="Waves to exclude"
              ariaLabel="Waves to exclude"
              data-cy="tracker-config-waves-exclude"
              [showStepper]="true"
              [formField]="trackerConfigForm.customWavesExclude"
            />
            <p class="form-text text-xs text-muted mb-0">
              {{ wavesExcludeHelpText() }}
            </p>
          </div>
        }
      </div>
    </div>
  </ps-drawer-body>
</ps-drawer>
